import React from 'react';

import { Box, Stack, xcss } from '@atlaskit/primitives';
import { media } from '@atlaskit/primitives/responsive';

export const LeftHandSideWrapper = ({ children }: { children: React.ReactNode }) => {
	return (
		<Box xcss={wrapperStyles}>
			<Stack spread="space-between" xcss={stackStyles}>
				{children}
			</Stack>
		</Box>
	);
};

const wrapperStyles = xcss({
	backgroundColor: 'elevation.surface',
	padding: 'space.300',
	[media.above.sm]: {
		padding: 'space.800',
	},
});

const stackStyles = xcss({
	height: '100%',
});
